import styles from './Footer.module.css'

function Footer(){
    return (
        <footer className={styles.footer}>
            &copy; Copyright Marvel - 2023
        </footer>
    )
}

export default Footer